//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'products-grid-infinite',
  components: {
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
    //
    AudioListItem: () => import('@motionelements/product2025/src/components/AudioListItem.vue'),
  },
  props: {
    elements: {
      type: Array,
      required: true,
    },
    mediaType: {
      type: String,
      default: 'motionelements',
    },
    infiniteId: [String, Number],
    isStemCard: Boolean,
    isProduct2025: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      identifier: +new Date(),
    };
  },
  computed: {
    isAudio() {
      return isProductType('audio', this.mediaType);
    },
  },
  watch: {
    infiniteId() {
      this.identifier += 1;
    },
  },
  methods: {
    infiniteHandler(e) {
      this.$emit('load-more', e);
    },
  },
};
